<div class="mb-3">
    <mwp-translation />
</div>
<form [formGroup]="loginForm" method="post" action="/" onsubmit="return false;">
    <div class="mb-3">
        <mwp-input [form]="loginForm" labelName="Email" nameForControl="email" placeholder="Email" inputType="email" autoComplete="email" autofill />
    </div>
    <div class="mb-3">
        <mwp-input [form]="loginForm" labelName="Password" nameForControl="password" inputType="password" autoComplete="current-password" />
    </div>
    <div>
        @if (useSecondaryCaptcha) {
        <mwp-captcha-google [form]="loginForm" [nameForRadioControl]="reCaptchaToken" [nameForRadioControlId]="reCaptchaTokenId" (emitReloadCaptcha)="reloadCaptcha($event)" />
        } @else {
        <mwp-captcha-cloudflare [form]="loginForm" [nameForRadioControl]="reCaptchaToken" [nameForRadioControlId]="reCaptchaTokenId" (emitReloadCaptcha)="reloadCaptcha($event)" />
        }
    </div>
</form>
<div class="w-100 mb-3">
    <div class="d-flex justify-content-center">
        <button type="submit" class="mwp-button w-100 mb-3" [disabled]="!loginForm.valid" (click)="submitLogIn()">
            <mwp-text-translate text="Login" jsonKey="login" />
        </button>
    </div>
    <div class="d-flex justify-content-center">
        <button class="mwp-button-secondary w-100 mb-3" [routerLink]="route.Register">
            <mwp-text-translate text="Register" jsonKey="register" />
        </button>
    </div>
    <div class="d-flex justify-content-center">
        <button class="mwp-button-secondary w-100" [routerLink]="route.ResetPassword" >
            <mwp-text-translate text="Reset Password" jsonKey="resetPassword" /> 
        </button>
    </div>
</div>
<div class="mobile-app-link">
    <div>
        <a [href]="appleURL" target="_blank">
            <img src="/assets/images/apple_store_black.svg" alt="Apple Store" class="browser-img" width="134" height="45" />
        </a>
    </div>
    <div>
        <a [href]="androidURL" target="_blank">
            <img src="/assets/images/google_play.svg" alt="Google Play" class="browser-img" width="151" height="45" />
        </a>
    </div>
</div>